import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Constant } from '../constant';

var jsonResponse: any;
@Injectable({
  providedIn: 'root'
})
export class ContactInformationService {

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(private http: HttpClient, private constant: Constant) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    headers = headers.set('Authorization', 'Bearer ' + localStorage.getItem('access_token'));
    this.httpOptions.headers = headers;
  }

  search(params): Observable<any> {
    return this.http.post<any>(this.constant.API_ENDPOINT + '/visitor-info-transaction/search?page='+params["page"]+"&perPage="+params["perPage"], JSON.stringify(params),
    this.httpOptions).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  exportExcel(params): Observable<any> {
    let url = this.constant.API_ENDPOINT + '/visitor-info-transaction/excel';
    return this.http.post(url, JSON.stringify(params), {
      responseType: "blob",
      headers: new HttpHeaders().append('Content-Type', 'application/json; charset=utf-8')
                                .append('Authorization', 'Bearer ' + localStorage.getItem('access_token'))
    });
  }

  // Error handling
  handleError(error) {
  console.log(error);
  let errorMessage = '';
  if(error.error && error.error.data) {
    errorMessage = error.error.data.error_message;
  }
  return throwError(errorMessage);
  }
}